<script setup lang="ts">
import { cn } from '@/lib/utils'
import Typography from '../ui/typography/Typography.vue'
const {
  value,
  title,
  size = 'large'
} = defineProps<{
  value: number | string
  title: string
  size?: 'small' | 'large'
}>()
</script>

<template>
  <div
    :class="
      cn({
        'flex flex-col bg-dark-grey h-fit rounded-lg': true,
        'py-[12px] px-[14px]': size !== 'small',
        'p-2': size === 'small'
      })
    "
  >
    <div class="invisible opacity-0 px-[14px] py-[12px] absolute"></div>
    <Typography class="font-semibold text-[18px]">{{ value }}</Typography>
    <Typography class="font-normal text-[10px]" color="secondary">{{ title }}</Typography>
  </div>
</template>
